<ng-container *ngFor="let branch of branches; trackBy: trackByName; let i = index; let len = count">
  <div *ngIf="branch.default" class="px-3 py-2 font-bold fs-09 header-list subpixel-antialiased">Default</div>
  <div *ngIf="len > 1 && i === 1" class="px-3 py-2 font-bold fs-09 header-list subpixel-antialiased">
    Recent branches
  </div>
  <div *ngIf="len > 5 && i === 6" class="px-3 py-2 font-bold fs-09 header-list subpixel-antialiased">
    Other branches
  </div>
  <button
    mat-menu-item
    class="h-[40px] lh-[40px] flex list font-normal justify-between items-center"
    [attr.data-test]="'button-git-branch-' + branch.name"
    (click)="branchClicked.emit(branch)"
    [class.active]="activeBranch?.name === branch.name"
    [disabled]="activeBranch?.name === branch.name"
    [class.bg-primary-100]="selectedBranch?.name === branch.name"
  >
    <fa-icon
      class="shrink-0 pr-1 fs-09"
      [style.margin-right.px]="10"
      [matTooltip]="activeBranch?.name === branch.name ? 'Active Branch' : ''"
      [icon]="['fal', activeBranch?.name === branch.name ? 'check' : 'code-branch']"
      matTooltipClass="main-menu-tooltip"
    ></fa-icon>
    <span class="inline-flex flex-1 min-w-0 fs-08 subpixel-antialiased">
      <ng-template
        [ngTemplateOutlet]="itemTemplate || defaultTemplate"
        [ngTemplateOutletContext]="{ $implicit: branch }"
      ></ng-template>
    </span>
  </button>
</ng-container>
<ng-template #defaultTemplate [templateContext]="itemContext" let-branch>
  <span class="flex-1 min-w-0 truncate subpixel-antialiased">
    {{ branch.name }}<span class="fs-08" *ngIf="!branch.published">&nbsp;(local)</span>
  </span>
  <y42-time-ago
    [date]="branch.committerDate"
    [relativeConfig]="{ showIfDaysDiff: 5, format: timeAgoFormat }"
    class="ml-auto fs-08 shrink-0 subpixel-antialiased"
  ></y42-time-ago>
</ng-template>
